import { BehaviorSubject, of, from } from 'rxjs';
import { switchMap, tap, map, mergeMap, retry } from 'rxjs/operators';

/** app数据服务 */
class AppService {
  password = {
    overall: '20268888',
    auth: '8867',
  };
  auth$ = new BehaviorSubject(false);
  overall$ = new BehaviorSubject(false);
  confirm$ = new BehaviorSubject({ isOpen: false, data: {} });
}

/** 单例对象函数 */
const service = (() => {
  // 隐藏的Class的构造函数
  // function TodayCilpService() {}

  // 未初始化的单例对象
  let service;

  return {
    // 创建/获取单例对象的函数
    getInstance: () => {
      if (!service) {
        service = new AppService();
      }
      return service;
    },
  };
})();
export const appService = service.getInstance();
